import type { ChaliceStore } from '../types';

export const selectCanonicalUrl = (state: ChaliceStore) =>
  state.seo.canonicalUrl;

export const selectAlternateLinks = (state: ChaliceStore) =>
  state.seo?.alternateLinks;
